module.exports = __webpack_public_path__ + "media/images/payment-uniteller-f2c213359db321a588129767772ffab7.png";